import React from 'react';

// Styles & Assets
import styles from './LanguageDropdown.module.css';
import { RiArrowDownSFill } from 'react-icons/ri';

// Hooks
import { useState } from 'react';

// Language
import { useTranslation } from 'react-i18next';
import { getAllLanguages } from '../../../i18n';

const LanguageDropdown: React.FC = () => {

    const { i18n } = useTranslation();

    const [showDropdown, setShowDropdown] = useState<boolean>(false);

    const handleClickDropdown = () => setShowDropdown(isShowDropdown => !isShowDropdown);

    const handleClickLanguage = (language: string) => {
        i18n.changeLanguage(language);
        setShowDropdown(false);
    };

    const allLanguages = getAllLanguages();

    return (
        <div style={{ position: 'relative'}}>
            <button onClick={handleClickDropdown} className={styles.container}>
                <p>{i18n.language}</p>
                <RiArrowDownSFill className={styles.icon} />
            </button>
            {showDropdown &&
                <div className={styles.dropdown}>
                    <div className={styles.languagesContainer}>
                        {allLanguages.map(language => 
                            <button onClick={() => handleClickLanguage(language)} key={language} className={styles.languageText}>
                                {language}
                            </button>
                        )}
                    </div>
                </div>
            }
        </div>
    );
};

export default LanguageDropdown;